import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MockAdminData, MockManageAdminsData, MockManageLicensesProdList } from 'app/models/data/mock/admin';
import { AccessType, LicenseData } from 'app/models/admin.model';
import { ResultResponse } from 'app/models/common.model';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { AdminService } from 'app/services/admin.service';
import { SharedDataService } from 'app/services/sharedData.service';
import { ProductName } from 'app/models/products.model';
import { UserService } from 'app/users/user.service';
import { CustomerService } from 'app/services/customer.service';
import { AuthService, Passport } from 'app/services/auth.service';
import * as uuid from 'uuid';
import { finalize } from 'rxjs';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-manage-admins',
  templateUrl: './manage-admins.component.html',
  styleUrls: ['../admin-common.scss']
})

export class ManageAdminsComponent implements OnInit {

  @ViewChild(MatTable) table! : MatTable<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('addAdminDialog') addAdminDialog!: TemplateRef<any>;
  @ViewChild('deleteUserDialog') deleteUserDialog!: TemplateRef<any>;

  introMessage!: string;
  productList: string[] = [];
  selectedProduct!: string;
  columnsToDisplay: string[] = ['fName', 'lName','email','hasAccess','action'];
  dataSource = new MatTableDataSource<any>();
 
  selRow!: number;
  adminForm!: FormGroup;
  adminDataList: LicenseData[] = [];
  initialDataList: any;
  needsUpdate: boolean = false;
  email: any;
  emailForAdd: any;
  
  addAdminForm!: FormGroup;
  addAdminDialogRef!: MatDialogRef<any, any>;
  deleteUserDialogRef!: MatDialogRef<any, any>;
  initialAddFormValues: any;
  msgText!: string;
  agreementId: string = "";
  loaded: boolean = false;
  totalLicenses: number = 0;
  action: string = "";
  rowToDelete: number = -1;
  accessTypesList : AccessType[] = [
    { code: "AccessOnly", desc : 'Regular User' },
    { code: "Administrator", desc : 'Administrator' },
    { code: "AdministratorWithAccess", desc : 'Administrator With Access' },
  ] 
  accessTypes = {
    'AccessOnly': 'Regular User',
    'Administrator': 'Administrator' ,
    'AdministratorWithAccess': 'Administrator With Access' 
  }
  addAccess!: string;
  usersLoadingComplete: boolean = false;

  constructor(
    private alertService: AlertsService,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private userService: UserService,    
    private sharedDataService: SharedDataService,
    private changeDetectorRefs: ChangeDetectorRef,
    private customerService: CustomerService,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
    }, 1000);    
  }

  ngOnInit() {   
    let token: Passport  = {
      id: uuid.v4(),
      userFlow: 'admin'
    }
    if(typeof this.userService.profile !== "undefined") {
      token['customerNumber'] = this.userService.profile.customerNumber;
    } else {
      token['customerNumber'] = '';
    }
    //console.log (`this.userService.profile.customerNumber ${this.userService.profile.customerNumber}`);
     this.authService.getToken(token)
             .pipe(
              finalize(() => {
                //console.log (`!!! manageAdmins profile ${JSON.stringify(this.userService.profile)}`);
                this.retrieveDetails();
                //this.changeDetectorRefs.detectChanges();
              }
            )
          )
           .subscribe();
  
  }

  linkData() {
    this.initializeForm();
    this.dataSource = new MatTableDataSource((this.adminList as FormArray).controls);
    this.dataSource.paginator = this.paginator;
    this.loaded = true;
  }

  retrieveDetails() {
    this.introMessage = MockManageAdminsData.introMessage;
    this.sharedDataService.getSubscriptions.subscribe( data => {    
              if(data === null) {
                    const prods = [Object.keys(ProductName)[0]];
                    this.customerService.fetchSubscriptions(this.userService.profile.customerNumber, prods).subscribe({
                      next: (res) => {
                        if (res.Data !== null) {       
                          this.sharedDataService.setSubscriptions(res.Data) 
                          const subscriptions = res.Data.filter( (d) => d.Status.Name === "Active");
                          for (const sub of subscriptions) {
                            this.agreementId = sub.AgreementId;
                            if (this.productList.indexOf(sub.Components[0].ProductName) === -1) {      
                              this.productList.push(sub.Components[0].ProductName);
                              this.totalLicenses = this.totalLicenses + sub.Components[0].QuantityOrdered;         
                            }
                            for (const person of sub.Participants) {
                              if (!this.userExists(person.Email)) {
                              //if (!this.userExists(person.Email)) {
                                const name:string[] = person.FullName.split(" ");
                                const lastName = name.length > 2 ? name[2] : name[1];
                                let participant: LicenseData = {
                                email: person.Email,
                                firstName: name[0],
                                lastName: lastName,
                                customerNumber: person.CustomerNumber,
                                agreementId: sub.AgreementId,
                                accessType: person.AccessType
                              }
                                this.adminDataList.push(participant);                
                              } 
                            }
                            this.customerService.getInvitedUsers(sub.AgreementId, "admin").subscribe({
                              next: (resInv) => {
                                if (resInv.Data !== null) {
                                  for(const  inv of resInv.Data) {
                                    if (!this.userWithIdExists(inv.Id)) {
                                      let participant: LicenseData = {
                                      email: inv.EmailAddress,
                                      firstName: inv.FirstName,
                                      lastName: inv.LastName,
                                      customerNumber: "",
                                      id: inv.Id,
                                      agreementId: sub.AgreementId,
                                      accessType: inv.Access
                                      }
                                      this.adminDataList.push(participant);
                                    }                  
                                  }  
                                }
                                this.linkData();  
                              },
                              error: (err) => {console.log(err.message);
                                this.linkData();
                              }
                            });                             
                          } 
                        }
                      },
                      error: (err) => { 
                        console.log(err); 
                      }              
                    }); 
      } else {          
        const subscriptions = data.filter( (d) => d.Status.Name === "Active");  
        for (const sub of subscriptions) {    
            this.agreementId = sub.AgreementId;
            if (this.productList.indexOf(sub.Components[0].ProductName) === -1) {      
              this.productList.push(sub.Components[0].ProductName);    
              this.totalLicenses = this.totalLicenses + sub.Components[0].QuantityOrdered;      
            }
            for (const person of sub.Participants) {
              if (!this.userExists(person.Email)) {
                const name:string[] = person.FullName.split(" ");
                const lastName = name.length > 2 ? name[2] : name[1];
                let participant: LicenseData = {
                email: person.Email,
                firstName: name[0],
                lastName: lastName,
                customerNumber: person.CustomerNumber,
                agreementId: sub.AgreementId,
                accessType: person.AccessType
              }
                this.adminDataList.push(participant);
              }              
            }
            this.customerService.getInvitedUsers(sub.AgreementId, "admin").subscribe({
              next: (resInv) => {
                if (resInv.Data !== null) {
                  for(const  inv of resInv.Data) {
                    if (!this.userWithIdExists(inv.Id)) {
                      let participant: LicenseData = {
                      email: inv.EmailAddress,
                      firstName: inv.FirstName,
                      lastName: inv.LastName,
                      customerNumber: "",
                      id: inv.Id,
                      agreementId: sub.AgreementId,
                      accessType: inv.Access
                      }
                      this.adminDataList.push(participant);
                    }  
                  }  
                }
                this.linkData();                
              },
              error: (err) => {console.log(err.message);
                this.linkData();
              }
            });                             
          }
        }
        this.usersLoadingComplete = true;   
      }  
    ); 
  }

  retrieveData(prodId: string) {
    this.adminService.getManageAdminData(prodId).subscribe({
      next: (data: LicenseData[]) => {
        if(data) {
          this.adminDataList = data;
          //refresh data
          this.refreshAdminForm(data)
          this.dataSource = new MatTableDataSource((this.adminList as FormArray).controls);
        }
      }, 
      error: err => {
          this.alertService.displayError("Error occured retrieving data");
      } 
    });
  }

  initializeForm() {
    this.adminForm = this.formBuilder.group({
      adminList : this.formBuilder.array(this.adminDataList.map(
        lic => this.formBuilder.group({
          //licenseId: new FormControl(lic.licenseId),
          firstName: [ lic.firstName, Validators.required],
          lastName:[ lic.lastName, Validators.required],
          email:[ lic.email, [Validators.required, Validators.email]],
          selected: [ false, ''],
          accessType: [ lic.accessType]
        })
      ))
    });
    this.initialDataList = Object.assign({}, this.adminList.value);
  }

  get adminList() {
    return this.adminForm.get('adminList') as FormArray;
  }

  getRow(indx: any) {
    return indx + this.paginator.pageIndex * this.paginator.pageSize;
  }

  deleteAdmin() {    
    this.usersLoadingComplete = false;
    const email: string = this.adminList.at(this.rowToDelete).get('email')?.value;
    const remaining = this.adminDataList.filter( data => data.email !== email);
    const ids: number[] = this.getDeletedIds(email);
    this.adminService.deleteLicenseData(remaining, ids).subscribe({
      next: (res: ResultResponse)=> {
        if(res.Data && JSON.parse(res.Data).Data === "Success") {
          this.alertService.displaySuccess("User/admin has been removed successfully");
          let delObj = Object.assign({}, this.adminList.value[this.rowToDelete]);
          delete delObj.selected; //remove the selected element from the object as its not needed for the delete call
          //Update the display
          this.adminDataList = remaining;
          this.adminList.removeAt(this.rowToDelete);
          this.dataSource = new MatTableDataSource((this.adminList as FormArray).controls);
          //this.changeDetectorRefs.detectChanges();
          this.sharedDataService.setSubscriptions(null);
          this.dataSource.paginator = this.paginator;      
          this.rowToDelete = -1;
          this.usersLoadingComplete = true;
        } else
          this.alertService.displayError("Error occured while deleting user/admin");
          this.rowToDelete = -1;
          this.usersLoadingComplete = true;
      }, error: err => {
        this.alertService.displayError("Error occured while deleting user/admin");
        this.rowToDelete = -1;
        this.usersLoadingComplete = true;
      } 
    });
    
  }

  checkForDuplicateEmail(control: AbstractControl): boolean {
    let exists = false;
    this.adminList.value.forEach(element => {
      if(element.email === control?.value) { 
          setTimeout(() => control?.setErrors({'alreadyExists': true}) );
          exists = true;
          return exists;
        }
      return exists;
    });
    return exists;
  }

  saveEdit(row: any, product: string) {
    let indx = this.getRow(row);
    this.email = this.adminList.at(indx).get('email');
    let userExists = this.checkForDuplicateEmail(this.email);
    if(!this.hasInvalidData(indx, userExists)){
    let updatedFields: any = {};
    this.findUpdatedFields(this.adminList.value[indx], updatedFields, this.initialDataList[indx], false);
    if(this.needsUpdate) {
      updatedFields['licenseId'] = row+1;
      let requestBody : Partial<LicenseData> = {};
      Object.assign(requestBody, updatedFields)
    }
    this.adminList.at(indx).get('selected')?.setValue(false);
    }
  }

  hasInvalidData(row: any, userExists: boolean) {
    if(userExists)
      return true;
    if(!this.adminList.controls[row].valid)
      return true;
    if(!this.adminList.controls[row].touched && this.adminList.controls[row].pristine)
      return true;
    return false;
  }

  cancel(row: any) {
    let index = this.getRow(row);
    let updatedFields: any = {};
    this.findUpdatedFields(this.adminList.value[index], updatedFields, this.initialDataList[index], false);
    if(this.needsUpdate) {
      //iterate and reset the specific fields like
      Object.keys(updatedFields).forEach(fld => {
        this.adminList.at(index).get(fld)?.setValue(this.initialDataList[index][fld])
      }) 
    }
    this.adminList.at(index).get('selected')?.setValue(false);
  }

  findUpdatedFields(formGroup : FormGroup, updatedFields:any, initialFormValues: any, forAdd: boolean) {
    this.needsUpdate = false;
    let fGroup = !forAdd? formGroup : formGroup.controls;
     Object.keys(fGroup).forEach(key => {
      if(key != 'selected') {//} && key != 'licenseId') {
        let formElement = !forAdd? formGroup[key] : formGroup.controls[key].value;
        if(initialFormValues[key] != formElement) {
          updatedFields[key]= formElement;
          this.needsUpdate = true; 
        }
      }
    });
  }

  addAdmin(product: string) {
      this.initializeAddForm();
      this.action ="add"
      this.addAdminDialogRef = this.dialog.open(this.addAdminDialog, {
        width: '350px',
        height: '660px',
      });
      this.initialAddFormValues = Object.assign({}, this.addAdminForm.value);
      this.selectedProduct = product;
  }

  deleteUser(row: any, product: string) {
    this.selectedProduct = product;
    this.rowToDelete = this.getRow(row);
    this.deleteUserDialogRef = this.dialog.open(this.deleteUserDialog);
  }

  editUser(row: any, product: string) {
    let indx = this.getRow(row);
    const email: string = this.adminList.at(indx).get('email')?.value;
    const firstName: string = this.adminList.at(indx).get('firstName')?.value;
    const lastName: string = this.adminList.at(indx).get('lastName')?.value;
    const access: string = this.adminList.at(indx).get('accessType')?.value;
    this.action ="edit"
    this.addAdminForm = this.formBuilder.group({
      firstName: [ {value: firstName, disabled: true}, Validators.required],
      lastName:[ {value: lastName, disabled: true}, Validators.required],
      email:[ {value: email, disabled: true}, [Validators.required, Validators.email]],
      selected:[false,''],
      accessType: [access, Validators.required]
    });
    this.addAdminDialogRef = this.dialog.open(this.addAdminDialog, {
      width: '350px',
      height: '650px',
    });
    this.initialAddFormValues = Object.assign({}, this.addAdminForm.value);
    this.selectedProduct = product;
  }

  initializeAddForm() : void {
    this.addAdminForm = this.formBuilder.group({
      firstName: [ '', Validators.required],
      lastName:[ '', Validators.required],
      email:[ '', [Validators.required, Validators.email]],
      selected:[false,''],
      accessType: ['', Validators.required]
    });
  }

  disableSaveBtn() {
    if(!this.addAdminForm.valid) 
      return true; 
    if(!this.addAdminForm.touched && this.addAdminForm.pristine)  
      return true;
    return false;
  }

  saveData() {
    //check if user already exists
    this.emailForAdd = this.addAdminForm.get('email');
    let userExists = this.checkForDuplicateEmail(this.emailForAdd);
    if(!userExists || this.action === "edit") {
      this.needsUpdate = false;
      let updFields :any = {};
      this.findUpdatedFields(this.addAdminForm, updFields, this.initialAddFormValues, true);
      this.msgText = '';
      if(this.needsUpdate) {
        let request: Partial<LicenseData> = {};
        Object.assign(request, updFields);
        const data: LicenseData = {
          firstName: request.firstName + '',
          lastName: request.lastName + '',
          email: request.email + '',
          accessType: request.accessType + '',
          customerNumber: this.userService.profile.customerNumber,          
          agreementId: this.agreementId 
        }
        this.usersLoadingComplete = false;
        this.adminService.addLicenseData(data).subscribe({
          next: res => {
            if(res !== null && res.Data !== null && res.Data.toLowerCase().includes("success")) {
              this.reloadData();
              if (res.Data.toLowerCase().includes("updated")) {
                this.alertService.displaySuccess("User/admin has been updated successfully.");
              } else {
                this.alertService.displaySuccess("User/admin has been added successfully.");
              }
              /* update table
              this.adminList.insert(this.adminList.length, this.addAdminForm)
              this.dataSource = new MatTableDataSource((this.adminList as FormArray).controls);
              this.changeDetectorRefs.detectChanges();
              this.dataSource.paginator = this.paginator; 
              */
            } else {
              let msg:string = "";
              if (res !== null) msg = res.ErrorMessage;
              this.alertService.displayError("Error occured while adding user/admin. " + msg);
              this.usersLoadingComplete = true;
            }  
          }, error: err => {
            this.alertService.displayError("Error occured while adding user/admin. " + err.error.ErrorMessage);
            this.usersLoadingComplete = true;
          } 
        }); 
      }
      this.addAdminDialogRef.close();
    }
  }

  cancelAdd() {
    this.addAdminDialogRef.close();
  }

  refreshAdminForm(data: LicenseData[]) {
    this.adminForm.patchValue({
      adminList : this.formBuilder.array(data.map(
        lic => this.formBuilder.group({
        firstName: lic.firstName,
        lastName: lic.lastName,
        email: lic.email
      })))
    })
  }

  userExists(email:string): boolean {
    let exists = false;
    this.adminDataList.forEach( function(element) { if(element.email === email) exists = true; });      
    return exists;
  }

  userWithIdExists(id:number): boolean {
    let exists = false;
    this.adminDataList.forEach( function(element) { if(element.id === id) exists = true; });      
    return exists;
  }  

  getDeletedIds(email: string): number[] {
    const user = this.adminDataList.filter(element => element.email === email);      
    return (user[0].id !== null && typeof user[0].id !== 'undefined') ? [user[0].id] : [];
  } 

  reloadData() {
    this.loaded = false;
    this.adminDataList.length = 0;
    this.adminList.clear();
    this.sharedDataService.setSubscriptions(null);
    this.retrieveDetails();
  }

  gotoCatalog() {
    window.open(environment.onlineCoding, '_blank');
  }  

  get usedLicenseCount() {
    let count = 0;
    for (let c of this.adminList.controls) {
      if (c.get('accessType')?.value === "AdministratorWithAccess" || c.get('accessType')?.value === "AccessOnly") {
      
        count++;
      } 
    }
    return count;
  }
}
